import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Box,
  Text,
  VStack,
  HStack,
  Button,
  Flex,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  useDisclosure,
  StackDivider,
  Textarea,
  useToast,
  useColorModeValue,
  Spinner,
  Input,
  Center
} from '@chakra-ui/react';
import axiosInstance from '../utils/axiosInstance';
import { CopyIcon } from "@chakra-ui/icons";
import { getAccessToken, getCurrentUserId } from '../utils/auth';
import MediaComponent from '../components/User/Content/Media';
import axios from "axios"
import { jwtDecode } from 'jwt-decode';

const BookingDetail = () => {
  const { bookingId } = useParams();
  const [booking, setBooking] = useState(null);
  const [loading, setLoading] = useState(true); // Loading state for initial data fetching
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [userType, setUserType] = useState('');
  const [isStarted, setIsStarted] = useState(false);
  const [showReviewInput, setShowReviewInput] = useState(false);
  const [reviewClaim, setReviewClaim] = useState('');
  const [reviewSubmitted, setReviewSubmitted] = useState(false);
  const [thankYouMessage, setThankYouMessage] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const navigate = useNavigate();
  const toast = useToast();
  const cardBg = useColorModeValue('white', 'gray.700');
  const bgColor = useColorModeValue('white', 'black');
  const textColor = useColorModeValue('black', 'white');
  const headingColor = useColorModeValue('black', 'white');
  const borderColor = useColorModeValue('gray.200', 'white');
  const avatarBorderColor = useColorModeValue('black', 'white');
  const avatarColor = useColorModeValue('black', 'white')
  const isEditable = localStorage.getItem('user_type') === "photographer";
  const frontendUrl = window.location.href
  const currentUserId = getCurrentUserId();
  const [thisUserItem, setThisUserItem] = useState(null);
  const [thisUserStatus, setThisUserStatus] = useState('');
  const [thisItemId, setThisItemId] = useState(null);
  const [hasCheckedIn, setHasCheckedIn] = useState(false);


  

  
  useEffect(() => {
    const fetchBookingDetails = async () => {
      setLoading(true);
      const backendUrl = process.env.NODE_ENV === 'production'
        ? process.env.REACT_APP_BACKEND_URL
        : 'http://localhost:8080';
      try {
        const response = await axios.get(`${backendUrl}/booking/${bookingId}`);
        setBooking(response.data);
        setUserType(localStorage.getItem('user_type'));
        setLoading(false);
      } catch (err) {
        console.error('Error fetching booking details:', err);
        setError(true);
        setErrorMessage("You don't have access to this booking or an error occurred.");
        setLoading(false);
        onOpen();
      }
    };

    fetchBookingDetails();
  }, [bookingId, onOpen]);

  useEffect(() => {
    if (booking && booking.items && currentUserId) {
      const foundItem = booking.items.find(item => item.user_id === currentUserId);
      setThisUserItem(foundItem || null);
      setThisUserStatus(foundItem?.status || '');
      setThisItemId(foundItem?.user_id || null); // Make sure you’re using the item’s unique `id`, not user_id
      setHasCheckedIn(!!foundItem?.checked_in_at);
    }
  }, [booking, currentUserId]);
  
  
  // For Participants to mark status.
  const handleItemStatusUpdate = async (itemId, newStatus) => {
    try {
      const token = await getAccessToken();
      const backendUrl = process.env.NODE_ENV === 'production'
        ? process.env.REACT_APP_BACKEND_URL
        : 'http://localhost:8080';
  
      const response = await axios.post(
        `${backendUrl}/bookings/${bookingId}/items/${itemId}/status`,
        { status: newStatus },
        { headers: { Authorization: `Bearer ${token}` } }
      );
  
      if (response.data.success) {
        toast({
          title: `Status set to "${newStatus}"`,
          status: 'success',
          duration: 3000,
          isClosable: true,
        });

        if (itemId === thisItemId) {
          setThisUserStatus(newStatus);
        }
        
        
      }
    } catch (err) {
      toast({
        title: 'Error updating status',
        description: err.message,
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };
  
  const formatTime = (time) => {
    if (!time) return '';
    const [hour, minute] = time.split(':');
    const hourNum = parseInt(hour, 10);
    const period = hourNum >= 12 ? 'PM' : 'AM';
    const formattedHour = hourNum % 12 === 0 ? 12 : hourNum % 12;
    return `${formattedHour}:${minute}${period}`;
  };
  

  const copyBookingLink = () => {
    console.log("Booking",booking)
    const bookingLink = `${frontendUrl}`;
    navigator.clipboard.writeText(bookingLink)
      .then(() => {
        toast({
          title: "Copied to Clipboard",
          description: "Booking link has been copied to your clipboard.",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      })
      .catch(() => {
        toast({
          title: "Error",
          description: "Failed to copy booking link. Please try again.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      });
  };

  const handleActionClick = async (action) => {
    try {
      const token = await getAccessToken();
      const backendUrl = process.env.NODE_ENV === 'production'
        ? process.env.REACT_APP_BACKEND_URL
        : 'http://localhost:8080';
      const response = await axiosInstance.post(
        `${backendUrl}/bookings/${bookingId}/complete_by_customer`,
        { reviewClaim },
        {
          headers: {
            'Authorization': `Bearer ${token}`,
          },
        }
      );

      if (response.data.success) {
        if (action === 'start') {
          setIsStarted(true);
        } else if (action === 'complete') {
          setThankYouMessage(true);
        } else if (action === 'review') {
          setReviewSubmitted(true);
        }

        // Re-fetch the booking details after the action
        //const updatedResponse = await axiosInstance.get(`${backendUrl}/booking/${bookingId}`);
        //setBooking(updatedResponse.data);

        toast({
          title: `Booking ${action} successfully`,
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
      } else {
        toast({
          title: `Failed to ${action} booking.`,
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (err) {
      console.error(`Error processing booking ${action}:`, err);
      toast({
        title: `Error processing booking ${action}`,
        description: err.response.data.error,
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  console.log("isEDITABLE", isEditable)

  const renderActionButton = () => {
    if (thankYouMessage) {
      return (
        <Box bg={cardBg} p={4} textAlign="center" borderRadius="md" shadow="md">
          <Text>Thank you for using the platform.</Text>
        </Box>
      );
    }
  
    if (userType !== 'customer' && thisUserItem) {
      const showAcceptDecline = thisUserStatus === 'pending';
      const showCheckIn = thisUserStatus === 'accepted' && !hasCheckedIn;
  
      return (
        <HStack spacing={4}>
          {showAcceptDecline && (
            <>
              <Button
                colorScheme="blue"
                onClick={() => handleItemStatusUpdate(thisItemId, 'accepted')}
              >
                Accept
              </Button>
              <Button
                colorScheme="red"
                onClick={() => handleItemStatusUpdate(thisItemId, 'declined')}
              >
                Decline
              </Button>
            </>
          )}
  
          {showCheckIn && (
            <Button
              colorScheme="teal"
              onClick={() => handleItemStatusUpdate(thisItemId, 'checked-in')}
            >
              📍 Check In
            </Button>
          )}
        </HStack>
      );
    }
    if (currentUserId === booking.customer_id) {
      return (
        <HStack spacing={4}>
          <Button colorScheme="yellow" onClick={() => setShowReviewInput(true)}>
            Request Review
          </Button>
          <Button colorScheme="green" onClick={() => handleActionClick('complete')}>
            Mark as Complete
          </Button>
        </HStack>
      );
    }
  
    return null;
  };
  
  

  if (loading) {
    return (
    <Flex minH="100vh" alignItems="center" justifyContent="center">
      <Spinner size="xl" />
    </Flex>
    )
  }

  if (!booking) {
    return (
      <Center height="100vh"> {/* Center the spinner */}
        <Spinner size="xl" thickness="4px" speed="0.65s" color="blue.500" />
      </Center>
    );
  }
  // Ensure customer appears in participants
  const customerParticipant = {
    user_id: booking.customer_id,
    name: `${booking.customer_first_name} ${booking.customer_last_name}`,
    user_type: 'customer',
    avatar: booking.customer_avatar, // if you have a customer avatar URL later
    phone_number: booking.customer_number,
    email: booking.customer_email,
    role: 'customer',
  };

  const participantsWithCustomer = booking?.items.some(item => item.user_id === booking.customer_id)
    ? booking.items
    : [customerParticipant, ...booking.items];

  // Sort: always put customer first
  const sortedParticipants = [
    ...participantsWithCustomer.filter(item => item.user_id === booking.customer_id),
    ...participantsWithCustomer.filter(item => item.user_id !== booking.customer_id)
  ];

  // Only show private info if current user is a participant
  const isParticipant = participantsWithCustomer.some(item => item.user_id === currentUserId);

  return (
    <VStack spacing={6} p={6} bg={bgColor} minH="100vh">
      <Box bg={bgColor} p={6} borderRadius="md" shadow="md" w="full">
        <VStack spacing={4} divider={<StackDivider borderColor={borderColor} />}>
        <Box w="full" mt={4} >
        <Text fontSize="2xl" fontWeight="bold" textAlign="center" mb={2}>
          Participants
        </Text>

        <VStack spacing={4} align="stretch">
          {sortedParticipants.map((item, index) => (
            <Flex
              key={index}
              p={4}
              borderWidth="1px"
              borderRadius="lg"
              borderColor={borderColor}
              bg={bgColor}
              align="center"
              justify="space-between"
              flexWrap="wrap"
            >
              <HStack spacing={4} align="center">
                {item.avatar && (
                  <Box boxSize="50px" borderRadius="full" overflow="hidden">
                    <img src={item.avatar} alt={item.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                  </Box>
                )}
                <Box>
                  <Text fontWeight="bold" fontSize="lg">{item.name}</Text>
                  <Text fontSize="sm" color="gray.500">{item.user_type}</Text>
                </Box>
              </HStack>

              {isParticipant && (
                <Box textAlign="right" mt={{ base: 2, md: 0 }}>
                  {item.phone_number && (
                    <Text fontSize="sm">📞 {item.phone_number}</Text>
                  )}

                  {/* Show Total & Rate only if NOT the customer */}
                  {currentUserId !== booking.customer_id && (
                    <>
                      {item.total && (
                        <Text fontSize="sm" fontWeight="semibold">
                          Total: ${item.total / 100}
                        </Text>
                      )}
                      {item.rate_per_hour && (
                        <Text fontSize="sm" fontWeight="semibold">
                          Hr Rate: ${item.rate_per_hour / 100}
                        </Text>
                      )}
                    </>
                  )}
                </Box>
              )}

            </Flex>
          ))}
        </VStack>

        </Box>


          <Text fontSize="lg" textAlign="center">
            {new Date(booking.created_at).toLocaleDateString('en-US', {
              weekday: 'short',
              year: 'numeric',
              month: 'short',
              day: 'numeric',
            })}
          </Text>
          <Text fontSize="md" textAlign="center">
          {formatTime(booking.start_time)} - {formatTime(booking.end_time)}
          </Text>
          <Text fontSize="md" textAlign="center" color="green.500" fontWeight="bold">
            Customer Total: ${booking.customer_total / 100 ? (booking.customer_total).toFixed(2) / 100 : 'N/A'}
          </Text>
          <Text fontSize="sm" textAlign="center" color="gray.500">
            Platform Fee: ${booking.platform_fee / 100 ? (booking.platform_fee).toFixed(2) / 100 : 'N/A'}
          </Text>

          <Box bg={bgColor} p={4} borderRadius="md" shadow="md">
            <Text fontWeight="bold" textAlign="center">Location</Text>
            <Text>{booking.location}</Text>
            <Text fontWeight="bold" textAlign="center">Booking Description</Text>
            <Flex alignItems="center">
            <Textarea
              value={booking.description}
              isReadOnly
              borderColor="gray.500"
              resize="none" // Prevent resizing
              whiteSpace="pre-wrap" // Preserve line breaks
              overflow="hidden" // Prevent unnecessary scrollbars
              minH="100px" // Set a minimum height
              maxW="100%" // Ensure the width doesn't overflow
              ref={(textarea) => {
                if (textarea) {
                  textarea.style.height = "auto"; // Reset height to auto
                  textarea.style.height = `${textarea.scrollHeight}px`; // Adjust height based on content
                }
              }}
            />
            </Flex>
          </Box>
        </VStack>
        <Flex justifyContent="center" mt={4}>
          {renderActionButton()}
        </Flex>

        {/* Copy Booking Link Section */}
        <Box mt={6} p={4} bg={cardBg} borderRadius="md" shadow="md" bgColor={bgColor}>
          <Text fontWeight="bold" textAlign="center" mb={2}>Share Booking Link</Text>
          <Flex alignItems="center">
            <Input 
              value={frontendUrl}
              isReadOnly
              borderColor={borderColor}
            />
            <Button 
              onClick={copyBookingLink} 
              ml={2} 
              colorScheme="blue"
              bgGradient='linear(to-r, #FF0080, #7928CA)' 
					    textColor={'white'}
					    _hover={{ bg: 'green.500', bgGradient: 'linear(to-r, red.500, purple.500)' }} 
              leftIcon={<CopyIcon />}
            >
              Copy
            </Button>
          </Flex>
        </Box>

        {showReviewInput && !reviewSubmitted && (
          <Box bg={cardBg} p={6} borderRadius="md" shadow="md" w="full">
            <Textarea
              placeholder="Write your review claim..."
              value={reviewClaim}
              onChange={(e) => setReviewClaim(e.target.value)}
              size="lg"
            />
            <Button colorScheme="yellow" mt={4} onClick={() => handleActionClick('review')}>
              Submit Review Claim
            </Button>
          </Box>
        )}

        {reviewSubmitted && (
          <Box bg={cardBg} p={6} borderRadius="md" shadow="md" w="full" textAlign="center">
            <Text>Thank you, our team will review your claim.</Text>
          </Box>
        )}

        {/* Error Modal */}
        <Modal isOpen={isOpen} onClose={onClose} isCentered>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Error</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Text>{errorMessage}</Text>
            </ModalBody>
            <ModalFooter>
              <Button colorScheme="blue" onClick={onClose}>
                Close
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>

        {/* Media Component */}
        <MediaComponent 
          photos={[]} 
          videos={[]} 
          booking={booking}
          isEditable={isEditable}
        />
      </Box>
    </VStack>
  );
};

export default BookingDetail;
